import { AppConst } from 'src/app/shared/constants/app-const';
import { NoiseLatestSiteData } from 'src/app/shared/interfaces/latest-site-data';
import { SensorHistory } from 'src/app/shared/interfaces/sensor-history';

import {
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { AreaChartComponent, LegendPosition } from '@swimlane/ngx-charts';

import {
  LineChartResultDto,
  LineChartResultSeriesDto,
} from '../../charts.interface';
import { ChartsService } from '../../charts.service';

@Component({
  selector: 'app-vibration-line-chart',
  templateUrl: './vibration-line-chart.component.html',
  styleUrls: ['./vibration-line-chart.component.scss'],
})
export class VibrationLineChartComponent implements OnChanges {
  @Input() data: NoiseLatestSiteData = {} as NoiseLatestSiteData;
  @Input() chartRange: string = 'daytime';
  @ViewChild(AreaChartComponent) chart: AreaChartComponent | null = null;

  results: LineChartResultDto[] = [];

  // Line chart options
  view: [number, number] = [600, 400];
  showXAxis = true;
  showYAxis = true;
  gradient = true;
  showLegend = false;
  legendTitle = '振動 (dB)';
  legendPosition = LegendPosition.Below;
  showXAxisLabel = false;
  xAxisLabel = 'Year';
  showYAxisLabel = false;
  yAxisLabel = 'Population';
  yScaleMin = 0;
  yScaleMax = AppConst.NOISE_LINE_CHART_Y_SCALE_MAX;

  colorScheme = 'cool';
  lineColor = '#9C27B0';
  customColors = (value: string) => {
    return this.lineColor;
  };

  timeline = true;

  sensorId = '';
  dataList: LineChartResultSeriesDto[] = [];

  constructor(private chartsService: ChartsService) {}

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    this.sensorId = this.data.id;
    this.setChartWidth();

    const histories = await this.getHistories();
    this.clearAllData();
    this.createDataSets(histories);

    // 表示対象風速データの最大値が10を超えていたら、グラフの縦軸もそれに合わせる
    const vibrationL10 = this.getVibrationL10(histories);
    if (vibrationL10 > AppConst.NOISE_LINE_CHART_Y_SCALE_MAX) {
      this.yScaleMax = vibrationL10;
    }

    // console.log(this.wbgtDataList.length);

    this.results = [];
    this.results.push({
      name: '振動',
      series: this.dataList,
    });

    if (this.chart) {
      this.chart.update();
    }
  }

  onResize(event: UIEvent) {
    this.setChartWidth();
  }

  setChartWidth() {
    this.view[0] = this.chartsService.getChartWidthFromWindowWidth(
      window.innerWidth
    );
  }

  onSelect(event: any) {}

  async getHistories() {
    let histories: SensorHistory[] | null = null;
    if (this.chartRange === '' || this.chartRange === 'daytime') {
      histories = await this.chartsService.getDaytimeSensorHistory(
        this.sensorId
      );
    } else if (this.chartRange === 'day') {
      histories = await this.chartsService.getDaySensorHistory(this.sensorId);
    } else if (this.chartRange === 'week') {
      histories = await this.chartsService.getWeekSensorHistory(this.sensorId);
    } else if (this.chartRange === 'month') {
      histories = await this.chartsService.getMonthSensorHistory(this.sensorId);
    }

    return histories;
  }

  getVibrationL10(histories: SensorHistory[] | null) {
    if (histories === null) return 0;

    const noiseArray: number[] = [];
    for (let history of histories) {
      if (history === undefined) continue;

      if (history.vibrationL10 !== undefined) {
        noiseArray.push(history.vibrationL10);
      }
    }

    return Math.max.apply(null, noiseArray);
  }

  createDataSets(histories: SensorHistory[] | null) {
    if (histories === null) return;

    const result = this.chartsService.createVibrationChartDataSets(
      this.chartRange,
      histories
    );
    if (result !== undefined) {
      this.dataList = result.vibration;
    }
  }

  clearAllData() {
    this.dataList = [];
  }
}
